import { ADJUST_FONT_SIZE, SET_FONT_SIZE } from './constants';

const initialState = {
  font_size: undefined,
  adjust_font_size: undefined,
};

// Frist Mobile group by screen width;
const firstMobileGroup = window.innerWidth < 1200 && window.innerWidth >= 992;
// Second Mobile group by width;
const secondMobileGroup = window.innerWidth < 992 && window.innerWidth >= 576;
// Third Mobile group by width;
const thirdMobileGroup = window.innerWidth < 576 && window.innerWidth >= 420;
// Fourth Mobile group by width;
const fourthMobileGroup = window.innerWidth < 420;

// Fonts coefficients by screen width;
const firstMobile = {
  'firstGroup': 2,
  'secondGroup': 6,
  'thirdGroup': 6,
  'fourthGroup': 22,
};

const secondMobile = {
  'firstGroup': 4,
  'secondGroup': 6,
  'thirdGroup': 10,
  'fourthGroup': 20,
};

const thirdMobile = {
  'firstGroup': 8,
  'secondGroup': 6,
  'thirdGroup': 10,
  'fourthGroup': 20,
};

const fourthMobile = {
  'firstGroup': 10,
  'secondGroup': 8,
  'thirdGroup': 12,
  'fourthGroup': 18,
};

const changeStyles = (fontSize) => {
  // 24px
  const firstGroup = document.querySelectorAll(
    '.menu *, .nav-item *, .leader-link *, .header-footer__button *, .page-item__title *, div.orders-item > a, div.meetings-item__content > a, .film-item__name',
  );
  for (let i = 0; i < firstGroup.length; i += 1) {
    const elem = firstGroup[i];
    elem.style.fontSize = `${parseInt(fontSize, 10)}px`;
  }
  // 18px
  const secondGroup = document.querySelectorAll(
    'div.main-tab__item > a, .thing-select *, .footer-menu *, .page-item__content *, .gallery-item__content *, .decree-item__content *, .page-gov__right *, .awards-subtitle',
  );
  for (let i = 0; i < secondGroup.length; i += 1) {
    const elem = secondGroup[i];
    elem.style.fontSize = `${parseInt(fontSize, 10) - 6}px`;
  }
  // 14px
  const thirdGroup = document.querySelectorAll(
    '.saidbar-item__box *, div.header-head__box > ul > li',
  );
  for (let i = 0; i < thirdGroup.length; i += 1) {
    const elem = thirdGroup[i];
    elem.style.fontSize = `${parseInt(fontSize, 10) - 10}px`;
  }
  // 20px
  const fourthGroup = document.querySelectorAll(
    '.events-content *, .page-content *, .film-item__text *, div.tab-content > ul > li > a',
  );
  for (let i = 0; i < fourthGroup.length; i += 1) {
    const elem = fourthGroup[i];
    elem.style.fontSize = `${parseInt(fontSize, 10) - 4}px`;
  }
};

const changeStylesMobile = (fontSize, mobileCoefficient) => {
  // 20px
  const firstGroup = document.querySelectorAll(
    '.menu *, ul.nav > li > a, .main-swiper__title *, .main-section__title *, .footer-logo__link *, .paginations *, .page-item__title *, .search *, div.saidbar-item > a, .header-footer__button *',
  );
  for (let i = 0; i < firstGroup.length; i += 1) {
    const elem = firstGroup[i];
    elem.style.fontSize = `${fontSize - mobileCoefficient.firstGroup}px`;
  }

  // 18px
  const secondGroup = document.querySelectorAll(
    'div.main-tab__item > a, .main-tab__title *, .thing-select *, .footer-menu *, .page-item__content *, .gallery-item__content *, .decree-item__content *, .page-gov__right *, .awards-subtitle, .leader-link *, .main-link__container *, .footer-social__title *, .orders-item *,  .breadcrumbs-container > nav > ol > li, div.meetings-item__content > a, .book_filter *',
  );
  for (let i = 0; i < secondGroup.length; i += 1) {
    const elem = secondGroup[i];
    elem.style.fontSize = `${fontSize - mobileCoefficient.secondGroup}px`;
  }

  // 14px
  const thirdGroup = document.querySelectorAll(
    '.main-swiper__info *, .saidbar-item__date *, .footer-social__service *, .orders-box *, .events-head-date *',
  );
  for (let i = 0; i < thirdGroup.length; i += 1) {
    const elem = thirdGroup[i];
    elem.style.fontSize = `${fontSize - mobileCoefficient.thirdGroup}px`;
  }

  // Event by ID;
  const eventById = document.querySelectorAll(
    '.events-head__title *, .events-content *',
  );
  for (let i = 0; i < eventById.length; i += 1) {
    const elem = eventById[i];
    elem.style.fontSize = `${mobileCoefficient.fourthGroup}px`;
  }
};

const fontSizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FONT_SIZE:
      return {
        ...state,
        font_size: action.payload,
      };
    case ADJUST_FONT_SIZE:
      if (window.innerWidth > 1200) {
        return {
          ...state,
          adjust_font_size: changeStyles(action.payload),
        };
      } else if (firstMobileGroup) {
        return {
          ...state,
          adjust_font_size: changeStylesMobile(action.payload, firstMobile),
        };
      } else if (secondMobileGroup) {
        return {
          ...state,
          adjust_font_size: changeStylesMobile(action.payload, secondMobile),
        };
      } else if (thirdMobileGroup) {
        return {
          ...state,
          adjust_font_size: changeStylesMobile(action.payload, thirdMobile),
        };
      } else if (fourthMobileGroup) {
        return {
          ...state,
          adjust_font_size: changeStylesMobile(action.payload, fourthMobile),
        };
      }
      break;
    default:
      return state;
  }
};

export default fontSizeReducer;
